import React from 'react'
import { Link } from 'react-router-dom'
import workHubLogo from "../../assets/images/brand/workhub-logo-dark.svg"
import "./Footer.scss";

const PinIcon = () => (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <path d="M10 18s6.5-6.1 6.5-10.4A6.5 6.5 0 0 0 3.5 7.6C3.5 11.9 10 18 10 18Z" />
        <circle cx="10" cy="7.6" r="2.4" />
    </svg>
);

const MailIcon = () => (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <rect x="2.5" y="4.5" width="15" height="11" rx="2.5" />
        <path d="M3 6.2 L10 11 L17 6.2" />
    </svg>
);

const PhoneIcon = () => (
    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
        <path d="M6.4 3.2 8 6.4 6.3 8.1a9.4 9.4 0 0 0 5.6 5.6l1.7-1.7 3.2 1.6v3a1.4 1.4 0 0 1-1.6 1.4A14.6 14.6 0 0 1 2 4.8a1.4 1.4 0 0 1 1.4-1.6h3Z" />
    </svg>
);

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer-section">
            <span className="footer-glow" aria-hidden="true" />

            <div className="container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <img src={workHubLogo} height={42} className="footer-logo" alt="WorkHub Manager" />
                        <p>
                            WorkHub keeps reports, timesheets, leave, projects and hiring in one place,
                            so your team spends less time on admin and more time on the work.
                        </p>
                    </div>

                    <nav className="footer-col" aria-label="Company">
                        <h5>Services</h5>
                        <ul>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/plans">Plans</Link></li>
                        </ul>
                    </nav>

                    <div className="footer-col footer-contact">
                        <h5>Reach us</h5>
                        <ul>
                            <li>
                                <span className="footer-ic"><PinIcon /></span>
                                Dallas Center, 6th &amp; 7th Floor, 83/1, No A1,
                                Knowledge City Rd, Rai Durg, Hyderabad, Telangana 500032
                            </li>
                            <li>
                                <span className="footer-ic"><MailIcon /></span>
                                <a href="mailto:info@workhubmanager.co.in">info@workhubmanager.co.in</a>
                            </li>
                            <li>
                                <span className="footer-ic"><PhoneIcon /></span>
                                <a href="tel:+914046515454">+91 40 4651 5454</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {year} WorkHub. All rights reserved.</p>
                    <ul>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Terms of Use</a></li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer
